/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Capacitor } from "@capacitor/core";

export const isPlatformMobile = (): boolean =>
  process.env.REACT_APP_USE_MOBILE_PLATFORM === "true" || Capacitor.isNativePlatform();

export const isPlatformWeb = (): boolean => !isPlatformMobile();

export const getPlatform = (): string => Capacitor.getPlatform();

export const isSafari = (): boolean => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
